import { Helper } from '../Helper';
export class NewHelper extends Helper {
    constructor(options = { noArgs: false }) {
        super();
        this.noArgs = options.noArgs || false;
    }
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.createObject);
        if (this.noArgs) {
            sb.emitOp(node, 'TUCK');
        }
        else {
            sb.emitPushInt(node, 3);
            sb.emitOp(node, 'XTUCK');
        }
        sb.emitOp(node, 'TUCK');
        sb.emitOp(node, 'OVER');
        sb.emitPushString(node, '__proto__');
        sb.emitOp(node, 'SWAP');
        sb.emitPushString(node, 'prototype');
        sb.emitHelper(node, options, sb.helpers.getPropertyObjectProperty);
        sb.emitHelper(node, options, sb.helpers.setDataPropertyObjectProperty);
        sb.emitHelper(node, sb.noPushValueOptions(options), sb.helpers.invokeConstruct({ noArgs: this.noArgs }));
        if (!optionsIn.pushValue) {
            sb.emitOp(node, 'DROP');
        }
    }
}

//# sourceMappingURL=NewHelper.js.map
